module.exports = __webpack_public_path__ + "static/media/bird_siting_page9.a9a27c01.png";